import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import styles from "./formulaireconnexion.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/composables/auth/use.auth";

const AuthLoginSchema = Yup.object({
  login: Yup.string()
    .required("L'identifiant est obligatoire")
    .min(3, "L'identifiant doit contenir au moins 3 caractères")
    .max(50, "L'identifiant ne peut pas dépasser 50 caractères"),

  password: Yup.string()
    .required("Le mot de passe est obligatoire")
    .min(8, "Le mot de passe doit comporter au moins 8 caractères")
    .matches(/[A-Z]/, "Le mot de passe doit contenir au moins une majuscule")
    .matches(/[0-9]/, "Le mot de passe doit contenir au moins un chiffre"),
});

    const JOURGUI_ADMIN = import.meta.env.VITE_JOURGUI_ADMIN;
const FormulaireConnexion: React.FC = () => {
  const navigate = useNavigate();
  const { loading, login } = useAuth();

  const handleMdpOublieClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate("/recuperation-acces");
  };

  return (
    <Formik
      initialValues={{
        login: "",
        password: "",
      }}
      validationSchema={AuthLoginSchema}
      onSubmit={async (values, { setSubmitting }) => {
          try {
              const utilisateur = await login(values);
              const typeJourguiV2 = [ "ADMINISTRATEUR","FOURNISSEUR", "VETERINAIRE", "TECHNIQUE", "TERRAIN", "SANITAIRE", 'ENTREPRISE', 'PARTICULIER', 'OFFICIER', 'AUTRE']
              if(typeJourguiV2.includes(utilisateur.type)) {
                  const uri=utilisateur.type === "ADMINISTRATEUR" ? "campagnes": (utilisateur.type === "FOURNISSEUR" || utilisateur.type === "TECHNIQUE") ? "commandes" : (utilisateur.type === "ENTREPRISE" || utilisateur.type === "PARTICULIER") ? "cheptel" : 'enrolements';
                  document.body.style.display = "none";
                  window.location.replace(`${JOURGUI_ADMIN}${uri}`);
              }
          } catch (e) {
          } finally {
              setSubmitting(false);
          }
      }}
    >
      <Form className={styles.formContainer}>
        <h2 className={styles.formTitle}>Connexion</h2>

        <div className={styles.formGroup}>
          <Field
            type="text"
            name="login"
            placeholder="Email"
            className={styles.input}
          />
          <ErrorMessage
            name="login"
            component="p"
            className={styles.errorMessage}
          />
        </div>

        <div className={styles.formGroup}>
          <Field
            type="password"
            name="password"
            placeholder="Mot de passe"
            className={styles.input}
          />
          <ErrorMessage
            name="password"
            component="p"
            className={styles.errorMessage}
          />
        </div>

        <button
          type="submit"
          className={styles.submitButton}
          disabled={loading}
        >
          {loading ? "Connexion en cours..." : "Se connecter"}
        </button>

        <div className={`${styles.forgotPassword} flex gap-2 mt-2 justify-end`}>
          <button
            type="button"
            className="text-xs text-primary cursor-pointer"
            onClick={handleMdpOublieClick}
          >
            Mot de passe oublié ?
          </button>
        </div>
      </Form>
    </Formik>
  );
};

export default FormulaireConnexion;
